/**
 * Centralized Form Actions Component
 * Provides consistent form action buttons and layout
 */

import React from 'react';
import Button from '../ui/Button';

export interface FormActionsProps {
  onSubmit: () => void;
  onCancel?: () => void;
  onReset?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  resetLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  showCancel?: boolean;
  showReset?: boolean;
  className?: string;
  submitVariant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'ghost';
  cancelVariant?: 'ghost' | 'secondary' | 'outline';
  resetVariant?: 'ghost' | 'secondary' | 'outline';
}

const FormActions: React.FC<FormActionsProps> = ({
  onSubmit,
  onCancel,
  onReset,
  submitLabel = 'حفظ',
  cancelLabel = 'إلغاء',
  resetLabel = 'إعادة تعيين',
  isLoading = false,
  disabled = false,
  showCancel = true,
  showReset = false,
  className = '',
  submitVariant = 'primary',
  cancelVariant = 'ghost',
  resetVariant = 'ghost'
}) => {
  return (
    <div className={`flex gap-6 justify-end ${className}`}>
      {showReset && onReset && (
        <Button
          type="button"
          variant={resetVariant}
          onClick={onReset}
          disabled={isLoading}
        >
          {resetLabel}
        </Button>
      )}

      {showCancel && onCancel && (
        <Button
          type="button"
          variant={cancelVariant}
          onClick={onCancel}
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>
      )}

      <Button
        type="submit"
        variant={submitVariant}
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={disabled || isLoading}
      >
        {submitLabel}
      </Button>
    </div>
  );
};

export default FormActions;
